module.exports = __webpack_public_path__ + "static/media/giropay-dark.ff3c753a.svg";